import { format } from 'date-fns';
// Task model, basic task operations
class Task {
    _id;
    _creationDate;
    completed;
    title;
    description;
    scheduleDate;
    deadlineDate;
    priority;
    lists;
    constructor(title, description = '', scheduleDate = '', deadlineDate = '', priority = '', id) {
        this._id = id ?? crypto.randomUUID();
        this._creationDate = createDate();
        this.completed = false;
        this.title = title;
        this.description = description;
        this.scheduleDate = scheduleDate;
        this.deadlineDate = deadlineDate;
        this.priority = priority;
        this.lists = ['All tasks'];
    }
}
export function createDate() {
    const now = new Date();
    return format(now, 'dd/MM/yyyy');
}
export default Task;
